<script>
  import componentEditorMixin from '@/components/ProductComponents/CreateComponents/componentEditorMixin.js'
  export default {
    name: "pipelineEditor",
    mixins: [componentEditorMixin],
    data() {
      return {
        directionList: [
          {
            value: 'topToBottom',
            name: '从上到下'
          },
          {
            value: 'bottomToTop',
            name: '从下到上'
          },
          {
            value: 'leftToRight',
            name: '从左到右'
          },
          {
            value: 'rightToLeft',
            name: '从右到左'
          },
        ],
        formList: [
          'flowForm',
          // ...
        ],
        ruleList: [
          {
            direction: [
              {
                required: true,
                message: '方向不能为空'
              },
            ],
          },
        ]
      }
    },

    // blockLengthPercent: 5,
    // blockNum: 10,
    // blockColor: 'blue',
    // timeInterval: 20,

    computed: {
      specificForms() {
        return (
          <div class="specificForms">
              <el-collapse-item class="specificForm" title="流动效果选项" name="2">
                <template slot="default">
                  <div class="specificForm">
                    <el-form id="flowForm" props={{model: this.newSettings}} ref="flowForm"  label-style={this.formLabelStyle}>
                      <el-form-item label="水流颜色" prop="background" label-position={this.labelPosition}>
                        <editor-field {...{attrs: {
                          value: this.newSettings.background,
                          type: 'color',
                          varList: this.varList,
                          varJson: this.varJson,
                          showEditButton: true,
                            label:"水流颜色",
                          }}}{...{on: {
                            'input': val=>{
                              this.newSettings.background = val;
                              this.handleConfirmBtnClick()
                            }
                          }}}>
                        </editor-field>
                      </el-form-item>
                      <el-form-item label="边框颜色" prop="borderColor" label-position={this.labelPosition}>
                        <editor-field {...{attrs: {
                          value: this.newSettings.borderColor,
                          type: 'color',
                          varList: this.varList,
                          varJson: this.varJson,
                          showEditButton: true,
                            label:"边框颜色",
                          }}}{...{on: {
                            'input': val=>{
                              this.newSettings.borderColor = val;
                              this.handleConfirmBtnClick()
                            }
                          }}}>
                        </editor-field>
                      </el-form-item>
                      <el-form-item label="方向" prop="direction" label-position={this.labelPosition}>
                        <editor-field {...{attrs: {
                          value: this.newSettings.direction,
                          type: 'radio',
                          radioList: this.directionList,
                          varList: this.varList,
                          varJson: this.varJson,
                          showEditButton: true,
                            label:"方向",
                          }}}{...{on: {
                            'input': val=>{
                              this.handleDirectionChange(val)
                              this.handleConfirmBtnClick()
                            }
                          }}}>
                        </editor-field>
                      </el-form-item>

                      {/* 流动间隔(毫秒) */}
                      <el-form-item label="流动速度" prop="speed" label-position={this.labelPosition}>
                        <editor-field {...{attrs: {
                          value: this.newSettings.speed,
                          type: 'input',
                          varList: this.varList,
                          varJson: this.varJson,
                          showEditButton: true,
                            label:"流动速度(模拟)",
                          }}}{...{on: {
                            'input': val => {
                              this.newSettings.speed = val
                              this.handleConfirmBtnClick()
                            },
                          }}}>
                        </editor-field>
                      </el-form-item>
                    </el-form>
                  </div>
                </template>
              </el-collapse-item>
          </div>
        )
      },
    },

    methods: {
      handleDirectionChange(val) {
        if (val === "topToBottom"  && (this.newSettings.direction == 'rightToLeft' || this.newSettings.direction == 'leftToRight')) {
          //长宽对调
          let tempHeight = this.newSettings.width
          let tempWidth = this.newSettings.height
          this.handleUniversalChangeSize(tempWidth, 'width')
          this.handleUniversalChangeSize(tempHeight, 'height')
          this.newSettings.transform = 'rotate(90deg)'
        }else if(val === "topToBottom"  && (this.newSettings.direction == 'topToBottom' || this.newSettings.direction == 'bottomToTop')){
          this.newSettings.transform = 'rotate(90deg)'
        }else if (val === "rightToLeft" && (this.newSettings.direction == 'topToBottom' || this.newSettings.direction == 'bottomToTop')) {
          //长宽对调
          let tempHeight = this.newSettings.width
          let tempWidth = this.newSettings.height
          this.handleUniversalChangeSize(tempWidth, 'width')
          this.handleUniversalChangeSize(tempHeight, 'height')
          this.newSettings.transform = 'rotate(180deg)'
        }else if (val === "rightToLeft"&& (this.newSettings.direction == 'rightToLeft' || this.newSettings.direction == 'leftToRight')) {
          this.newSettings.transform = 'rotate(180deg)'
        }else if (val === "bottomToTop" && (this.newSettings.direction == 'rightToLeft' || this.newSettings.direction == 'leftToRight')) {
          //长宽对调
          let tempHeight = this.newSettings.width
          let tempWidth = this.newSettings.height
          this.handleUniversalChangeSize(tempWidth, 'width')
          this.handleUniversalChangeSize(tempHeight, 'height')
          this.newSettings.transform = 'rotate(270deg)'
        }else if (val === "bottomToTop" && (this.newSettings.direction == 'topToBottom' || this.newSettings.direction == 'bottomToTop')) {
          this.newSettings.transform = 'rotate(270deg)'
        }else if(val === "leftToRight" && (this.newSettings.direction == 'topToBottom' || this.newSettings.direction == 'bottomToTop')){
          //长宽对调
          let tempHeight = this.newSettings.width
          let tempWidth = this.newSettings.height
          this.handleUniversalChangeSize(tempWidth, 'width')
          this.handleUniversalChangeSize(tempHeight, 'height')
          this.newSettings.transform = 'rotate(0deg)'
        }else if(val === "leftToRight" && (this.newSettings.direction == 'rightToLeft' || this.newSettings.direction == 'leftToRight')){
          this.newSettings.transform = 'rotate(0deg)'
        }

        this.newSettings.direction = val;
      },
    }
  }
</script>

<style>
</style>
